export const colors = {
	getPrimaryColor: function (): string {
		return this.purple[500]
	},

	gray: {
		0: "#FFFFFF",
		50: "#F7F7F7",
		100: "#EDEDED",
		200: "#D6D6D6",
		300: "#BCBCBC",
		400: "#9E9E9E",
		500: "#7A7A7A",
		600: "#5F5F5F",
		700: "#4A4A4A",
		800: "#333333",
		900: "#242424",
		950: "#141414"
	},

	purple: {
		50: "#F5F4FD",
		100: "#E6E4FA",
		200: "#CCC7F0",
		300: "#9B94DD",
		400: "#8179D5",
		500: "#6B62D1",
		600: "#5A52B8",
		700: "#4A439C",
		800: "#3A357D",
		900: "#2B275E",
		950: "#1A173D"
	},

	beige: {
		50: "#FBF8F2",
		100: "#F6F0E5",
		200: "#F1E7D7",
		300: "#ECE0CC",
		400: "#DDCDB3",
		500: "#C9B48F",
		600: "#AF996C",
		700: "#8E7A52",
		800: "#6F5F3F",
		900: "#55482F",
		950: "#2F2718"
	},

	blue: {
		50: "#F4F8FD",
		100: "#E8F1FB",
		200: "#D4E5F7",
		300: "#BFD8F3",
		400: "#B5D2F0",
		500: "#8EB6E6",
		600: "#6496D8",
		700: "#4A79BC",
		800: "#365E99",
		900: "#294872",
		950: "#172A45"
	},

	green: {
		50: "#F6FDEA",
		100: "#ECFBD6",
		200: "#DFF8BC",
		300: "#D0F6A6",
		400: "#C3F499",
		500: "#9FE86A",
		600: "#78CF46",
		700: "#5BA334",
		800: "#447C28",
		900: "#355F21",
		950: "#1C3511"
	},

	red: {
		50: "#FEF2F2",
		100: "#FEE2E2",
		200: "#FDCBCB",
		300: "#FBA7A6",
		400: "#F67473",
		500: "#EE5655",
		600: "#D92A29",
		700: "#B71F1E",
		800: "#971E1D",
		900: "#7E1F1E",
		950: "#440B0B"
	},

	yellow: {
		50: "#FFF9E6",
		100: "#FFF2CC",
		200: "#FFE699",
		300: "#FFD966",
		400: "#F7D24C",
		500: "#F2C94C",
		600: "#D9B23D",
		700: "#B8952F",
		800: "#8F7124",
		900: "#6B551B",
		950: "#3D2F0C"
	}
}
